import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-education-package',
  templateUrl: './education-package.component.html',
  styleUrls: ['./education-package.component.css']
})
export class EducationPackageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
